<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <!-- 主表单区域 -->
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="8" >
            <a-form-item :label="$t('label.number')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['code',validatorRules.code]" placeholder="请输入编号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['name',validatorRules.name]" :placeholder="$t('label.pleaseEnterTheName')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.batchNo')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag :trigger-change="true" @change="handleBatchCodeChange" v-decorator="['batchCode',validatorRules.batchCode]" type="list" dictCode="efs_md_breed_batch,name,code,valid_flag='Y' and del_flag='N'" placeholder="请输入养殖批次" />
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.farms')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select :placeholder="$t('label.pleaseSelectFarms')" v-decorator="['farmCode',validatorRules.farmCode]">
                <a-select-option
                  v-for="item in farmCodeList"
                  :key="item.orgCode"
                  :value="item.orgCode">
                  {{ item.departName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.grower')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select :placeholder="$t('label.pleaseSelectGrower')"  v-decorator="['farmerCode',validatorRules.farmerCode]">
                <a-select-option
                  v-for="item in farmerCodeList"
                  :key="item.code"
                  :value="item.code">
                  {{ item.name }}
                </a-select-option>
              </a-select>
              <!--<a-input v-decorator="['farmerCode']" placeholder="请输入养户"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.contracts')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select :placeholder="$t('label.pleaseSelectContract')" v-decorator="['conCode',validatorRules.conCode]">
                <a-select-option
                  v-for="item in conCodeList"
                  :key="item.code"
                  :value="item.code">
                  {{ item.name }}
                </a-select-option>
              </a-select>
              <!--<a-input v-decorator="['conCode']" placeholder="请输入合同"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.applicant')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                :triggerChange="true"
                dictCode="sys_user,realname,username,del_flag = '0'"
                v-decorator="['refApplicantId', {'initialValue': initApplyUser, rules: validatorRules.refApplicantId.rules}]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.documentDate')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('label.pleaseSelectDocumentDate')" v-decorator="['docDate', {'initialValue': initAccountPeriod, rules: validatorRules.docDate.rules}]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.remarks')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['notes']" :placeholder="$t('label.pleaseEnterANote')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.validOrNot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['validFlag',{'initialValue': 'Y'}]" :trigger-change="true" dictCode="sfyx"  :placeholder="$t('label.pleaseChooseWhetherItIsValidOrNot')"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
      <!-- 子表单区域 -->
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane tab="物资领用计划明细" :key="refKeys[0]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[0]"
          :loading="efsMdMaterialPlanDetailTable.loading"
          :columns="efsMdMaterialPlanDetailTable.columns"
          :dataSource="efsMdMaterialPlanDetailTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          :actionButton="true"
          @valueChange="handleValueChange"/>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>

  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'
  import { FormTypes,getRefPromise } from '@/utils/JEditableTableUtil'
  import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import {getQueryData,getCurrentUser} from '@/api/api'
  import moment from "moment"

  export default {
    name: 'EfsMdMaterialPlanForm',
    mixins: [JEditableTableMixin],
    components: {
      JFormContainer,
      JDate,
    },
    data() {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
          farmCodeList:[],//养殖场
          farmerCodeList:[],//养户
          conCodeList:[],//合同
        validatorRules: {
            code: {rules: [
                {required: true, message: '请输入编码!'},
                { validator: (rule, value, callback) => validateDuplicateValue('efs_md_material_plan', 'code', value, this.model.id, callback)},
                ]},
            name: {rules: [{required: true, message: '请输入名称!'}]},
            batchCode: {rules: [{required: true, message: '请选择养殖批次!'}]},
            farmCode: {rules: [{required: true, message: '请选择养殖场!'}]},
            farmerCode: {rules: [{required: true, message: this.$t('label.pleaseSelectGrower')}]},
            conCode: {rules: [{required: true, message: this.$t('label.pleaseSelectContract')}]},
            refApplicantId: {rules: [{required: true, message: '请选择申请人!'}]},
            docDate: {rules: [{required: true, message: this.$t('label.pleaseSelectDocumentDate')}]},
        },
        refKeys: ['efsMdMaterialPlanDetail', ],
        tableKeys:['efsMdMaterialPlanDetail', ],
        activeKey: 'efsMdMaterialPlanDetail',
        // efs_md_material_plan_detail
        efsMdMaterialPlanDetailTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '物料通用名编码',
              key: 'mmCode',
              type: FormTypes.select,
              dictCode:"efs_md_company_price_list as t1,mm_name,mm_code,version=(select max(version) from efs_md_company_price_list where t1.mm_code=mm_code) and del_flag='N' and valid_flag='Y'",
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '物料通用名名称',
              key: 'mmName',
              type: FormTypes.normal,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: this.$t('tableHeader.specification'),
              key: 'mmSpec',
              type: FormTypes.normal,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: this.$t('tableHeader.model'),
              key: 'mmModel',
              type: FormTypes.normal,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '计量单位',
              key: 'mmUnit',
              type: FormTypes.select,
              dictCode:"efs_stocking_msur_unit,name,code",
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
              disabled:true,
            },
            {
              title: this.$t('tableHeader.unitPrice'),
              key: 'unitPrice',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '计划数量',
              key: 'planQuantity',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: this.$t('tableHeader.remarks'),
              key: 'notes',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
          ]
        },
        url: {
          add: "/materialPickingPlan/efsMdMaterialPlan/add",
          edit: "/materialPickingPlan/efsMdMaterialPlan/edit",
          queryById: "/materialPickingPlan/efsMdMaterialPlan/queryById",
          efsMdMaterialPlanDetail: {
            list: '/materialPickingPlan/efsMdMaterialPlan/queryEfsMdMaterialPlanDetailByMainId'
          },
            queryByMtrlCodeWithMaxversion : '/companyPriceList/efsMdCompanyPriceList/queryByMtrlCodeWithMaxversion',
        },
          initApplyUser: null,
          initAccountPeriod: moment(new Date()).format('YYYY-MM-DD'),
      }
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：false流程表单 true普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
        getCurrentUser().then((res) => {
            if (res.success) {
                this.initApplyUser = res.result.username;
            }
        });
    },
    methods: {
      addBefore(){
        this.form.resetFields()
        this.efsMdMaterialPlanDetailTable.dataSource=[]
      },
      getAllTable() {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter() {
        let fieldval = pick(this.model,'code','name','batchCode','farmCode','farmerCode','conCode','sysOrgCode','refApplicantId','docDate','confirmId','confirmDate','createBy','createTime','updateBy','updateTime','approvalStatus','notes','validFlag','delFlag','tenantCode','thirdSysCode','syncStatus','syncMsg')
        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
        })
          if(this.model.id){
              getQueryData({batchCode: this.model.batchCode}).then((res) => {
                  if (res.success) {
                      this.farmCodeList = res.result.sysDeparts;
                      this.farmerCodeList=res.result.efsMdFarmers;
                      this.conCodeList=res.result.efsMdContracts;
                  }
              });
          }else{
              this.model.farmCode = "";
              this.model.farmerCode="";
              this.model.conCode="";
          }
        // 加载子表数据
        if (this.model.id) {
          let params = { id: this.model.id }
          this.requestSubTableData(this.url.efsMdMaterialPlanDetail.list, params, this.efsMdMaterialPlanDetailTable)
        }
      },
      /** 整理成formData */
      classifyIntoFormData(allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        return {
          ...main, // 展开
          efsMdMaterialPlanDetailList: allValues.tablesValue[0].values,
        }
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          })
        }
      },
      validateError(msg){
        this.$message.error(msg)
      },
     popupCallback(row){
       this.form.setFieldsValue(pick(row,'code','name','batchCode','farmCode','farmerCode','conCode','sysOrgCode','refApplicantId','docDate','confirmId','confirmDate','createBy','createTime','updateBy','updateTime','approvalStatus','notes','validFlag','delFlag','tenantCode','thirdSysCode','syncStatus','syncMsg'))
     },
        handleBatchCodeChange(value) {
            getQueryData({batchCode: value}).then((res) => {
                if (res.success) {
                    this.farmCodeList = res.result.sysDeparts;
                    this.farmerCodeList=res.result.efsMdFarmers;
                    this.conCodeList=res.result.efsMdContracts;
                }
            });
        },

        handleValueChange(event) {
            if(event.column.key === 'mmCode'){
                getAction(this.url.queryByMtrlCodeWithMaxversion, { code: event.row.mmCode }).then(res => {
                    if (res.success) {
                        this.$refs.efsMdMaterialPlanDetail.setValues([{
                            rowKey: event.row.id,
                            values: {
                                mmName: res.result.mmName,
                                mmSpec:res.result.spec,
                                mmModel:res.result.model,
                                mmUnit:res.result.unit,
                                unitPrice:res.result.price
                            }
                        }]);
                        this.$refs.efsMdMaterialPlanDetail.$forceUpdate();
                    } else {
                        this.$message.warning(res.message)
                    }
                })

            }
        },

    }
  }
</script>

<style scoped>
</style>